import { VideoMainPageMediaShare } from "./videoMainPageMediaShare";
import { SiteVideoData, SiteItemData } from "../../../../interfaces";
import { SiteVideoInline } from "../../../../siteWidgets/videoPlayer/genericInlineVideoPlayer/siteVideoInline";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { disablePageRefresh, enablePageRefresh } from "../../../../siteWidgets/siteWidgetUtils";
import { VerticalVideoOverlayPlayer } from "../../../verticalVideoOverlayPlayer/verticalVideoOverlayPlayer";
import { categoryObj } from "../../newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { MediaContentTypes } from "../../../../../constants/contentTypes";
import { applyFeedPrerolls, getLightboxFeed, LIGHTBOX_VIDEO_BEHAVIOR, LightboxFeedAdSettings, LightboxItem } from "../utils/videoPageLightboxFeed";
import * as axios from "axios";
import * as ReactDOM from "react-dom";

interface VideoPageMainProps {
    video: SiteItemData
    languageCode: string
    isMobileWeb: boolean
    domain: string
    displayVideoOnly?: boolean
    isShareFeedMode?: boolean
    feedJsonUrl?: string
    feedComponentName?: string
    isLTR?: boolean
    category?: categoryObj
}

interface VideoPageMainState {
    isLightboxOpen: boolean
    isFeedLoading: boolean
    feedItems: LightboxItem[]
    feedAdSettings: LightboxFeedAdSettings
}

export class VideoPageMain extends React.Component<VideoPageMainProps, VideoPageMainState>{
    public static siteScriptName = "VideoPageMain";

    constructor(props) {
        super(props);
        this.state = {
            isLightboxOpen: false,
            isFeedLoading: false,
            feedItems: [],
            feedAdSettings: null,
        };
    }

    private scrollPosition: number = 0;

    componentDidMount() {
        if (!this.isLightboxMode()) return;
        const { feedJsonUrl, feedComponentName } = this.props;
        if (!feedJsonUrl || !feedComponentName) {
            this.openLightbox();
            return;
        }

        const { videoPageId, mediaId } = this.props.video.media as SiteVideoData;
        this.setState({ isFeedLoading: true });
        axios.get(feedJsonUrl)
            .then((res: any) => {
                const { items, adSettings } = getLightboxFeed(res.data, feedComponentName, videoPageId, mediaId);
                this.setState({ feedItems: items, feedAdSettings: adSettings });
            })
            .catch(err => console.error("VideoPageMain: error getting lightbox feed:", err))
            .then(() => {
                this.setState({ isFeedLoading: false });
                this.openLightbox();
            });
    }

    componentWillUnmount() {
        if (this.state.isLightboxOpen) {
            enablePageRefresh();
            this.unlockBodyScroll();
        }
    }

    private isLightboxMode = () => {
        const { isShareFeedMode, video } = this.props;
        const media = video && video.media as SiteVideoData;
        return !!isShareFeedMode && !!media && media.mediaType === MediaContentTypes.MEDIA_VIDEO && !!media.videoPageId;
    }

    private openLightbox = () => {
        if (this.state.isFeedLoading || this.state.isLightboxOpen) return;
        disablePageRefresh();
        this.lockBodyScroll();
        this.setState({ isLightboxOpen: true });
    }

    private closeLightbox = () => {
        if (!this.state.isLightboxOpen) return;
        enablePageRefresh();
        this.unlockBodyScroll();
        this.setState({ isLightboxOpen: false });
    }

    private lockBodyScroll = () => {
        if (!this.props.isMobileWeb) return;
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = "100%";
    }

    private unlockBodyScroll = () => {
        if (!this.props.isMobileWeb) return;
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, this.scrollPosition);
    }

    private getLightboxItems = (): LightboxItem[] => {
        const media = this.props.video.media as SiteVideoData;
        const sharedItem: LightboxItem = {
            itemId: `videoPageMain_${media.mediaId}`,
            title: media.videoName,
            media: { ...media, ...LIGHTBOX_VIDEO_BEHAVIOR, videoType: "vertical_video" } as SiteVideoData,
        };
        return applyFeedPrerolls([sharedItem, ...this.state.feedItems], this.state.feedAdSettings);
    }

    public render() {
        const { video, languageCode, isMobileWeb, domain, displayVideoOnly, isLTR, category } = this.props;
        const { isLightboxOpen } = this.state;
        const { media, categoryName } = video;
        const { dateCreated, credit, videoName, mediaId, aspectRatio, poster } = media as SiteVideoData;
        const lang = languageCode.split("-")[0];
        const videoMainPageClass = `videoPageMain ${aspectRatio === "9:16" ? "vertical": ""}`;
        console.log(aspectRatio)
        const isLightboxMode = this.isLightboxMode();
        
        return (
            <div className={`${videoMainPageClass} ${displayVideoOnly ? "displayVideoOnly": ""}`}>
                {!displayVideoOnly && <div className="contentDiv">
                    {!isMobileWeb && <div className="videoPageMainCategory">{categoryName}</div>}
                    <div className="videoPageMainTitle">{videoName}</div>
                    <div className="videoPageMainTop">
                        <div className="videoPageMainDetails">
                            <span className="videoPageMainCredit">{credit}</span>
                            <span className="separator"></span>
                            <DateDisplay date={dateCreated} isArticle={true} />
                        </div>
                        <VideoMainPageMediaShare
                            categorySubChannel={"categorySubChannel"}
                            credit={credit}
                            articleId={mediaId}
                            showComments={false}
                            lang={lang}
                            isMobileWeb={isMobileWeb}
                            domain={domain} />
                    </div>
                </div>}
                <div className="videoWrapper">
                    {isLightboxMode ?
                        <div className="lightboxPoster" style={{ backgroundImage: `url(${poster})` }} onClick={this.openLightbox}>
                            <div className="lightboxPlayButton" />
                        </div>
                        :
                        <SiteVideoInline
                            data={media as SiteVideoData}
                            applyStickyness={true}
                            hideVideoAds={false}
                            isShareButton={true}
                            runArticleAutoPlayLogic={false} />
                    }
                </div>

                {isLightboxOpen && ReactDOM.createPortal(
                    <VerticalVideoOverlayPlayer
                        isLTR={isLTR}
                        domain={domain}
                        category={category}
                        isMobile={isMobileWeb}
                        isTitleVisible={true}
                        isOverlayOpen={true}
                        showPrerollAds={true}
                        selectedVideoIndex={0}
                        isSubTitleVisible={true}
                        languageCode={languageCode}
                        videoItems={this.getLightboxItems()}
                        onVideoOverlayClose={this.closeLightbox}
                    />,
                    document.body
                )}
            </div>

        )
    }
}
